import { ScrollView } from "@-/com.npmjs.react-native";
import type { ComponentPropsWithRef } from "react";
import { useHeaderScrollContentStyle } from "#header-scroll-content-style";
import { useGlassHeaderViewport } from "#use-glass-header-viewport";

/** Keeps resting content below the header fade while letting it scroll underneath the header. */
export function HeaderScrollView({
  glassHeaderOverlap,
  headerOverlap,
  scrollIndicatorInsets,
  style,
  suppressContentGap = false,
  ...props
}: ComponentPropsWithRef<typeof ScrollView> & {
  /** See `useGlassHeaderViewport`: the floating glass chrome's height on iOS 26. */
  glassHeaderOverlap?: number;
  headerOverlap?: number;
  /** Use explicit content padding when the toolbar already reserves the resting gap. */
  suppressContentGap?: boolean;
}) {
  const glass = useGlassHeaderViewport({
    glassHeaderOverlap,
    horizontal: props.horizontal,
    scrollIndicatorInsets,
    style,
  });
  const contentContainerStyle = useHeaderScrollContentStyle({
    ...props,
    headerOverlap: glass.headerOverlap ?? headerOverlap,
    // No fade to clear: the chrome's own gutter is the resting gap.
    suppressContentGap: glass.isActive || suppressContentGap,
  });
  return (
    <ScrollView
      {...props}
      contentContainerStyle={contentContainerStyle}
      scrollIndicatorInsets={glass.scrollIndicatorInsets}
      style={glass.style}
    />
  );
}
